import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const setServiceRequestFormData = (state, { payload }) => {
  return {
    ...state,
    data: {
      ...state.data,
      ...payload
    },
  };
};

const setServiceRequestFormNextStep = (state, { payload }) => {
  return {
    ...state,
    step: state.step + 1,
  };
};

const setServiceRequestFormPreviousStep = (state, { payload }) => {
  return {
    ...state,
    step: state.step - 1,
  };
};

const setServiceRequestFormStep = (state, { payload }) => {
  return {
    ...state,
    step: payload.step,
  };
};

const exitServiceRequestForm = (state) => {
  return {
    isVisible: false,
    step: 0,
    data: {},
  };
};
const clearServiceRequestFormData = (state, {payload}) => {
  return {
    isVisible: true,
    step: 0,
    data: payload,
  };
}
const setServiceRequestFromIsVisible = (state, { payload }) => {
  return {
    ...state,
    isVisible: payload,
  };
};

const initialState = {
  step: 0,
};

export default createReducer(initialState, {
  [TYPES.EXIT_SERVICE_REQUEST_FORM]: exitServiceRequestForm,
  [TYPES.SET_SERVICE_REQUEST_FORM_DATA]: setServiceRequestFormData,
  [TYPES.SET_SERVICE_REQUEST_FORM_IS_VISIBLE]: setServiceRequestFromIsVisible,
  [TYPES.SET_SERVICE_REQUEST_FORM_NEXT_STEP]: setServiceRequestFormNextStep,
  [TYPES.SET_SERVICE_REQUEST_FORM_PREVIOUS_STEP]: setServiceRequestFormPreviousStep,
  [TYPES.SET_SERVICE_REQUEST_FORM_STEP]: setServiceRequestFormStep,
  [TYPES.CLEAR_SERVICE_REQUESTS_FORM_DATA]: clearServiceRequestFormData
});
